import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useUserContext } from '../contexts/user-context'

function RequireAuth({ children }: { children: React.JSX.Element }) {
  const user = useUserContext().userState.user
  const location = useLocation()

  if (!user.token) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default RequireAuth